<template>
    <div id="app" :style="appStyle">
        <Nav/>
        <transition name="fade" mode="out-in" appear @after-leave="$root.$emit('triggerScroll')">
            <router-view :key="$route.path"/>
        </transition>
        <notifications classes="notification" width="500px" position="bottom center"/>
    </div>
</template>

<script>
import Nav from './components/Nav'

export default {
    name: 'App',
    components: {
        Nav
    },
    computed: {
        appStyle() {
            return {
                '--theme-color': this.$store.state.page.color,
                //'--main-color': '#2c3e50',
                '--main-color': '#000000',
                '--other-color': '#ffffff',
            }
        }
    },
}
</script>

<style lang="scss">
@import 'app.scss';
</style>
